export default function WhatWeDo (props) {
    return (
        <section id='what-we-do'>
            <div className="container" data-aos='fade-up'> 
            <h1 className="mb-3 header-title text-center text-lg-start">What We Do</h1>
                    {props.card}
            </div>
        </section>
    );
}